"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Метод поиска в строке подстроки не учитывая регистр
 * @param source - строка где ищем
 * @param substring - строка что ищем
 */
function isIncludeSubstring(source, substring) {
    if (!source) {
        return false;
    }
    if (!substring) {
        return true;
    }
    return source.toLowerCase().includes(substring.toLowerCase());
}
exports.isIncludeSubstring = isIncludeSubstring;
/**
 *
 * @param count - количество объектов
 * @param first - строка для одного объекта, например, "день"
 * @param second - строка для двух объектов, например, "дня"
 * @param more - строка для множества объектов, например, "дней"
 */
function getCountString(count, first, second, more) {
    if (count === 1 || (count !== 11 && count % 10 === 1)) {
        return first;
    }
    else if ((count >= 2 && count <= 4) ||
        (count !== 12 && count !== 13 && count !== 14 && count % 10 >= 2 && count % 10 <= 4)) {
        return second;
    }
    else {
        return more;
    }
}
exports.getCountString = getCountString;
/**
 * Удаляет начальные и конечные пробелы во всех полях объекта. Вложенные объекты не изменяются.
 * @param obj - объект для модификации
 */
function trimObjectValues(obj) {
    if (!obj) {
        return;
    }
    if (typeof obj === 'object') {
        for (var key in obj) {
            if (obj[key] && typeof obj[key] === 'string') {
                obj[key] = obj[key].trim();
            }
        }
    }
}
exports.trimObjectValues = trimObjectValues;
//# sourceMappingURL=index.js.map